export const CountryCodes = [
  {
    name: "Nepal",
    country_code: "+977",
    flag: "🇳🇵",
  },
  {
    name: "United Kingdom",
    country_code: "+44",
    flag: "🇬🇧",
  },
  {
    name: "United States",
    country_code: "+1",
    flag: "🇺🇸",
  },
  { name: "Afghanistan", country_code: "+93", flag: "🇦🇫" },
  { name: "Albania", country_code: "+355", flag: "🇦🇱" },
  { name: "Algeria", country_code: "+213", flag: "🇩🇿" },
  { name: "Andorra", country_code: "+376", flag: "🇦🇩" },
  { name: "Angola", country_code: "+244", flag: "🇦🇴" },
  { name: "Antigua and Barbuda", country_code: "+1-268", flag: "🇦🇬" },
  { name: "Argentina", country_code: "+54", flag: "🇦🇷" },
  { name: "Armenia", country_code: "+374", flag: "🇦🇲" },
  { name: "Australia", country_code: "+61", flag: "🇦🇺" },
  { name: "Austria", country_code: "+43", flag: "🇦🇹" },
  { name: "Azerbaijan", country_code: "+994", flag: "🇦🇿" },
  { name: "Bahamas", country_code: "+1-242", flag: "🇧🇸" },
  { name: "Bahrain", country_code: "+973", flag: "🇧🇭" },
  { name: "Bangladesh", country_code: "+880", flag: "🇧🇩" },
  { name: "Barbados", country_code: "+1-246", flag: "🇧🇧" },
  { name: "Belarus", country_code: "+375", flag: "🇧🇾" },
  { name: "Belgium", country_code: "+32", flag: "🇧🇪" },
  { name: "Belize", country_code: "+501", flag: "🇧🇿" },
  { name: "Benin", country_code: "+229", flag: "🇧🇯" },
  { name: "Bhutan", country_code: "+975", flag: "🇧🇹" },
  { name: "Bolivia", country_code: "+591", flag: "🇧🇴" },
  { name: "Bosnia and Herzegovina", country_code: "+387", flag: "🇧🇦" },
  { name: "Botswana", country_code: "+267", flag: "🇧🇼" },
  { name: "Brazil", country_code: "+55", flag: "🇧🇷" },
  { name: "Brunei", country_code: "+673", flag: "🇧🇳" },
  { name: "Bulgaria", country_code: "+359", flag: "🇧🇬" },
  { name: "Burkina Faso", country_code: "+226", flag: "🇧🇫" },
  { name: "Burundi", country_code: "+257", flag: "🇧🇮" },
  { name: "Cabo Verde", country_code: "+238", flag: "🇨🇻" },
  { name: "Cambodia", country_code: "+855", flag: "🇰🇭" },
  { name: "Cameroon", country_code: "+237", flag: "🇨🇲" },
  { name: "Canada", country_code: "+1", flag: "🇨🇦" },
  { name: "Central African Republic", country_code: "+236", flag: "🇨🇫" },
  { name: "Chad", country_code: "+235", flag: "🇹🇩" },
  { name: "Chile", country_code: "+56", flag: "🇨🇱" },
  { name: "China", country_code: "+86", flag: "🇨🇳" },
  { name: "Colombia", country_code: "+57", flag: "🇨🇴" },
  { name: "Comoros", country_code: "+269", flag: "🇰🇲" },
  { name: "Congo (Congo-Brazzaville)", country_code: "+242", flag: "🇨🇬" },
  { name: "Costa Rica", country_code: "+506", flag: "🇨🇷" },
  { name: "Croatia", country_code: "+385", flag: "🇭🇷" },
  { name: "Cuba", country_code: "+53", flag: "🇨🇺" },
  { name: "Cyprus", country_code: "+357", flag: "🇨🇾" },
  { name: "Czech Republic", country_code: "+420", flag: "🇨🇿" },
  {
    name: "Democratic Republic of the Congo",
    country_code: "+243",
    flag: "🇨🇩",
  },
  { name: "Denmark", country_code: "+45", flag: "🇩🇰" },
  { name: "Djibouti", country_code: "+253", flag: "🇩🇯" },
  { name: "Dominica", country_code: "+1-767", flag: "🇩🇲" },
  { name: "Dominican Republic", country_code: "+1-809", flag: "🇩🇴" },
  { name: "Ecuador", country_code: "+593", flag: "🇪🇨" },
  { name: "Egypt", country_code: "+20", flag: "🇪🇬" },
  { name: "El Salvador", country_code: "+503", flag: "🇸🇻" },
  { name: "Equatorial Guinea", country_code: "+240", flag: "🇬🇶" },
  { name: "Eritrea", country_code: "+291", flag: "🇪🇷" },
  { name: "Estonia", country_code: "+372", flag: "🇪🇪" },
  { name: "Eswatini", country_code: "+268", flag: "🇸🇿" },
  { name: "Ethiopia", country_code: "+251", flag: "🇪🇹" },
  { name: "Fiji", country_code: "+679", flag: "🇫🇯" },
  { name: "Finland", country_code: "+358", flag: "🇫🇮" },
  { name: "France", country_code: "+33", flag: "🇫🇷" },
  { name: "Gabon", country_code: "+241", flag: "🇬🇦" },
  { name: "Gambia", country_code: "+220", flag: "🇬🇲" },
  { name: "Georgia", country_code: "+995", flag: "🇬🇪" },
  { name: "Germany", country_code: "+49", flag: "🇩🇪" },
  { name: "Ghana", country_code: "+233", flag: "🇬🇭" },
  { name: "Greece", country_code: "+30", flag: "🇬🇷" },
  { name: "Grenada", country_code: "+1-473", flag: "🇬🇩" },
  { name: "Guatemala", country_code: "+502", flag: "🇬🇹" },
  { name: "Guinea", country_code: "+224", flag: "🇬🇳" },
  { name: "Guinea-Bissau", country_code: "+245", flag: "🇬🇼" },
  { name: "Guyana", country_code: "+592", flag: "🇬🇾" },
  { name: "Haiti", country_code: "+509", flag: "🇭🇹" },
  { name: "Honduras", country_code: "+504", flag: "🇭🇳" },
  { name: "Hungary", country_code: "+36", flag: "🇭🇺" },
  { name: "Iceland", country_code: "+354", flag: "🇮🇸" },
  { name: "India", country_code: "+91", flag: "🇮🇳" },
  { name: "Indonesia", country_code: "+62", flag: "🇮🇩" },
  { name: "Iran", country_code: "+98", flag: "🇮🇷" },
  { name: "Iraq", country_code: "+964", flag: "🇮🇶" },
  { name: "Ireland", country_code: "+353", flag: "🇮🇪" },
  { name: "Israel", country_code: "+972", flag: "🇮🇱" },
  { name: "Italy", country_code: "+39", flag: "🇮🇹" },
  { name: "Jamaica", country_code: "+1-876", flag: "🇯🇲" },
  { name: "Japan", country_code: "+81", flag: "🇯🇵" },
  { name: "Jordan", country_code: "+962", flag: "🇯🇴" },
  { name: "Kazakhstan", country_code: "+7", flag: "🇰🇿" },
  { name: "Kenya", country_code: "+254", flag: "🇰🇪" },
  { name: "Kiribati", country_code: "+686", flag: "🇰🇮" },
  { name: "Kuwait", country_code: "+965", flag: "🇰🇼" },
  { name: "Kyrgyzstan", country_code: "+996", flag: "🇰🇬" },
  { name: "Laos", country_code: "+856", flag: "🇱🇦" },
  { name: "Latvia", country_code: "+371", flag: "🇱🇻" },
  { name: "Lebanon", country_code: "+961", flag: "🇱🇧" },
  { name: "Lesotho", country_code: "+266", flag: "🇱🇸" },
  { name: "Liberia", country_code: "+231", flag: "🇱🇷" },
  { name: "Libya", country_code: "+218", flag: "🇱🇾" },
  { name: "Liechtenstein", country_code: "+423", flag: "🇱🇮" },
  { name: "Lithuania", country_code: "+370", flag: "🇱🇹" },
  { name: "Luxembourg", country_code: "+352", flag: "🇱🇺" },
  { name: "Madagascar", country_code: "+261", flag: "🇲🇬" },
  { name: "Malawi", country_code: "+265", flag: "🇲🇼" },
  { name: "Malaysia", country_code: "+60", flag: "🇲🇾" },
  { name: "Maldives", country_code: "+960", flag: "🇲🇻" },
  { name: "Mali", country_code: "+223", flag: "🇲🇱" },
  { name: "Malta", country_code: "+356", flag: "🇲🇹" },
  { name: "Marshall Islands", country_code: "+692", flag: "🇲🇭" },
  { name: "Mauritania", country_code: "+222", flag: "🇲🇷" },
  { name: "Mauritius", country_code: "+230", flag: "🇲🇺" },
  { name: "Mexico", country_code: "+52", flag: "🇲🇽" },
  { name: "Micronesia", country_code: "+691", flag: "🇫🇲" },
  { name: "Moldova", country_code: "+373", flag: "🇲🇩" },
  { name: "Monaco", country_code: "+377", flag: "🇲🇨" },
  { name: "Mongolia", country_code: "+976", flag: "🇲🇳" },
  { name: "Montenegro", country_code: "+382", flag: "🇲🇪" },
  { name: "Morocco", country_code: "+212", flag: "🇲🇦" },
  { name: "Mozambique", country_code: "+258", flag: "🇲🇿" },
  { name: "Myanmar", country_code: "+95", flag: "🇲🇲" },
  { name: "Namibia", country_code: "+264", flag: "🇳🇦" },
  { name: "Nauru", country_code: "+674", flag: "🇳🇷" },
  { name: "Netherlands", country_code: "+31", flag: "🇳🇱" },
  { name: "New Zealand", country_code: "+64", flag: "🇳🇿" },
  { name: "Nicaragua", country_code: "+505", flag: "🇳🇮" },
  { name: "Niger", country_code: "+227", flag: "🇳🇪" },
  { name: "Nigeria", country_code: "+234", flag: "🇳🇬" },
  { name: "North Korea", country_code: "+850", flag: "🇰🇵" },
  { name: "North Macedonia", country_code: "+389", flag: "🇲🇰" },
  { name: "Norway", country_code: "+47", flag: "🇳🇴" },
  { name: "Oman", country_code: "+968", flag: "🇴🇲" },
  { name: "Pakistan", country_code: "+92", flag: "🇵🇰" },
  { name: "Palau", country_code: "+680", flag: "🇵🇼" },
  { name: "Palestine", country_code: "+970", flag: "🇵🇸" },
  { name: "Panama", country_code: "+507", flag: "🇵🇦" },
  { name: "Papua New Guinea", country_code: "+675", flag: "🇵🇬" },
  { name: "Paraguay", country_code: "+595", flag: "🇵🇾" },
  { name: "Peru", country_code: "+51", flag: "🇵🇪" },
  { name: "Philippines", country_code: "+63", flag: "🇵🇭" },
  { name: "Poland", country_code: "+48", flag: "🇵🇱" },
  { name: "Portugal", country_code: "+351", flag: "🇵🇹" },
  { name: "Qatar", country_code: "+974", flag: "🇶🇦" },
  { name: "Romania", country_code: "+40", flag: "🇷🇴" },
  { name: "Russia", country_code: "+7", flag: "🇷🇺" },
  { name: "Rwanda", country_code: "+250", flag: "🇷🇼" },
  { name: "Saint Kitts and Nevis", country_code: "+1-869", flag: "🇰🇳" },
  { name: "Saint Lucia", country_code: "+1-758", flag: "🇱🇨" },
  {
    name: "Saint Vincent and the Grenadines",
    country_code: "+1-784",
    flag: "🇻🇨",
  },
  { name: "Samoa", country_code: "+685", flag: "🇼🇸" },
  { name: "San Marino", country_code: "+378", flag: "🇸🇲" },
  { name: "Sao Tome and Principe", country_code: "+239", flag: "🇸🇹" },
  { name: "Saudi Arabia", country_code: "+966", flag: "🇸🇦" },
  { name: "Senegal", country_code: "+221", flag: "🇸🇳" },
  { name: "Serbia", country_code: "+381", flag: "🇷🇸" },
  { name: "Seychelles", country_code: "+248", flag: "🇸🇨" },
  { name: "Sierra Leone", country_code: "+232", flag: "🇸🇱" },
  { name: "Singapore", country_code: "+65", flag: "🇸🇬" },
  { name: "Slovakia", country_code: "+421", flag: "🇸🇰" },
  { name: "Slovenia", country_code: "+386", flag: "🇸🇮" },
  { name: "Solomon Islands", country_code: "+677", flag: "🇸🇧" },
  { name: "Somalia", country_code: "+252", flag: "🇸🇴" },
  { name: "South Africa", country_code: "+27", flag: "🇿🇦" },
  { name: "South Korea", country_code: "+82", flag: "🇰🇷" },
  { name: "South Sudan", country_code: "+211", flag: "🇸🇸" },
  { name: "Spain", country_code: "+34", flag: "🇪🇸" },
  { name: "Sri Lanka", country_code: "+94", flag: "🇱🇰" },
  { name: "Sudan", country_code: "+249", flag: "🇸🇩" },
  { name: "Suriname", country_code: "+597", flag: "🇸🇷" },
  { name: "Sweden", country_code: "+46", flag: "🇸🇪" },
  { name: "Switzerland", country_code: "+41", flag: "🇨🇭" },
  { name: "Syria", country_code: "+963", flag: "🇸🇾" },
  { name: "Taiwan", country_code: "+886", flag: "🇹🇼" },
  { name: "Tajikistan", country_code: "+992", flag: "🇹🇯" },
  { name: "Tanzania", country_code: "+255", flag: "🇹🇿" },
  { name: "Thailand", country_code: "+66", flag: "🇹🇭" },
  { name: "Timor-Leste", country_code: "+670", flag: "🇹🇱" },
  { name: "Togo", country_code: "+228", flag: "🇹🇬" },
  { name: "Tonga", country_code: "+676", flag: "🇹🇴" },
  { name: "Trinidad and Tobago", country_code: "+1-868", flag: "🇹🇹" },
  { name: "Tunisia", country_code: "+216", flag: "🇹🇳" },
  { name: "Turkey", country_code: "+90", flag: "🇹🇷" },
  { name: "Turkmenistan", country_code: "+993", flag: "🇹🇲" },
  { name: "Tuvalu", country_code: "+688", flag: "🇹🇻" },
  { name: "Uganda", country_code: "+256", flag: "🇺🇬" },
  { name: "Ukraine", country_code: "+380", flag: "🇺🇦" },
  { name: "United Arab Emirates", country_code: "+971", flag: "🇦🇪" },
  { name: "Uruguay", country_code: "+598", flag: "🇺🇾" },
  { name: "Uzbekistan", country_code: "+998", flag: "🇺🇿" },
  { name: "Vanuatu", country_code: "+678", flag: "🇻🇺" },
  { name: "Vatican City", country_code: "+379", flag: "🇻🇦" },
  { name: "Venezuela", country_code: "+58", flag: "🇻🇪" },
  { name: "Vietnam", country_code: "+84", flag: "🇻🇳" },
  { name: "Yemen", country_code: "+967", flag: "🇾🇪" },
  { name: "Zambia", country_code: "+260", flag: "🇿🇲" },
  { name: "Zimbabwe", country_code: "+263", flag: "🇿🇼" },
];
